import React, { useEffect, useState } from "react";
import styles from "./frequentlyShared.module.scss";
import { useDispatch, useSelector } from 'react-redux';
import { fetchFrequentlySharedAssets } from 'actions/assets';
import _ from "lodash";
import cx from 'classnames';
import { useHistory } from 'react-router-dom';
import FileService from 'services/file.service';
import dateformat from 'dateformat';
import defaultAsset from 'images/default_asset.jpg';
import GenerateLink from "components/generateLink";
import LockIcon from "components/lockIcon";
import { deselectAsset, selectAsset } from 'actions/selection';
import { trackAdoptionMetricsForAssetDetailViewedEvent } from "actions/adoption";
import { InlineEllipsis } from "components/ellipsis";
import { REDIRECT_URL } from 'constants/actionTypes';
import { invalidateAssetSelection } from "actions/application";

export default function FrequentlyShared(props) {
  const dispatch = useDispatch();
  const history = useHistory();

  const webAppUrl = process.env.REACT_APP_WEBAPP_URL;

  const frequentlySharedAssets = useSelector((state) => _.get(state, 'assets.frequentlyShared.items') || []);
  const frequentlySharedAssetsLoading = useSelector((state) => _.get(state, 'assets.frequentlyShared.loading')) || false;
  const assets = useSelector((state) => _.get(state, `application.assets`) || []);
  const activeTab = useSelector((state) => _.get(state, 'application.activeTab') || null);

  const [generateLink, setGenerateLink] = useState(false);
  const [selectedAsset, setSelectedAsset] = useState();
  const [selectedAssets, setSelectedAssets] = useState([]);
  const [isPaperflite, setIsPaperflite] = React.useState(false);

  useEffect(() => {
    if(_.size(frequentlySharedAssets) === 0){
      dispatch(fetchFrequentlySharedAssets());
    }
  }, [])

  useEffect(() => {
    setSelectedAssets(assets);
  }, [assets])

  useEffect(() => {
    if (activeTab && activeTab.includes("app.paperflite.com")) {
      setIsPaperflite(true);
    }
  }, [activeTab])

  const handleGenerateLink = (asset) => {
    if (asset.settings && !asset.settings.share) {
      return;
    }
    setSelectedAsset(asset)
    setGenerateLink(true);
  }

  const handleSelectAsset = (selectedAsset) => {
    if(props.carousel){
      const assetUrl = `${webAppUrl}/assets/${selectedAsset.id}?source=chrome_extension`;
      window.open(assetUrl, "_blank");
      return;
    }

    if(_.includes(selectedAssets, selectedAsset)){
      dispatch(deselectAsset(selectedAsset));
      const filteredAssets = selectedAssets.filter(asset => asset.id != selectedAsset.id);
      setSelectedAssets(filteredAssets);
    }else{
      setSelectedAssets([...selectedAssets, selectedAsset]);
      const allAssets = [...selectedAssets, selectedAsset];
      allAssets.map(asset => dispatch(selectAsset(asset)));
    }
  }
  
  const handleBackClicked = () => {
    history.push("/paperflite-home")
  }

  const renderAssetSummary = (asset) => {
    if (asset.metadata.pages) {
      return (
        <div className={styles.metrics}>
          <span>{asset.metadata.pages} Pages</span>
        </div>
      );
    } else if (asset.metadata.video_duration) {
      return (
        <div className={styles.metrics}>
          <span>{formartVideoDuration(asset.metadata.video_duration)}</span>
        </div>
      );
    }

    return false;
  }

  const formartVideoDuration = (timeSpent) => {
    let timeSpentValue = `${padNumber(timeSpent, 1)} Seconds`;

    if (timeSpent >= 60) {
      var minutes = Math.round(timeSpent / 60);
      timeSpentValue = `${padNumber(minutes, 1)} Minute${minutes == 1 ? '' : 's'}`;
    }

    return timeSpentValue;
  }

  const padNumber = (number = 0, pad) => {
    number = Math.ceil(number);

    const length = pad - String(number).length + 1;
    let padding = '';
    if (length > 0) {
      padding = Array(pad - String(number).length + 1).join('0');
    }
    return padding + number;
  }

  const isSelected = (asset) => {
    return assets.map(item => item.id).includes(asset.id);
  }

  const handleAttachAssets = () => {
    history.push("/attachAssets");
  }

  const triggerMessageToPlugin = (message) => {
    window.parent.postMessage(message, "*");
  }

  const handleClick = (asset) => {
    dispatch(trackAdoptionMetricsForAssetDetailViewedEvent("Asset Detail Viewed", "Frequently Shared Assets", FileService.fileType(_.get(asset, "metadata"))));
    
    const url = `${webAppUrl}/assets/${asset.id}?source=chrome_extension`;

    if(isPaperflite){
      triggerMessageToPlugin({
        type: REDIRECT_URL,
        payload: url,
      });
    }
  }
  
  return (
    <>
      <div className={cx(styles.frequentlyShared, { 
        [styles.frequentlySharedPage]: !props.carousel,
        [styles.hideMask]: _.size(assets) > 0 && props.attachAssets
        })}>
        <div className={styles.frequentlySharedContent}>
        {!props.carousel &&
          <p className={styles.headerContainer}>
          <span className={styles.backButton} onClick={() => handleBackClicked()}>
          <i className="paperflite-left-arrow"/>
          <span className={styles.back}>
            frequently shared assets
          </span>
          </span>
          </p>
        }

        {selectedAsset && <GenerateLink entity={selectedAsset} type="asset" show={generateLink} setShow={setGenerateLink}/>}

        {props.carousel && <p className={styles.frequentlySharedTitle}>Frequently shared assets </p>}

          {!props.carousel && (
          <div className={cx(styles.assets, styles.adjustedAssets)}>
          {!frequentlySharedAssetsLoading && frequentlySharedAssets.map((asset, i) => {
            var assetSummary = renderAssetSummary(asset);
            return (
              <a 
                href={isPaperflite ? null : `${webAppUrl}/assets/${asset.id}?source=chrome_extension`} 
                target="_blank" 
                className={cx(styles.asset)} 
                onClick={(e) => {
                  e.stopPropagation();
                  handleClick(asset);
                  }}
              >
                <span className={cx(styles.assetIcon, {
                })}>
                  {asset.settings && !asset.settings.share && <LockIcon />}
                  <img
                    alt="asset thumbnail"
                    src={_.get(asset, "icon.thumbnail") || defaultAsset} 
                    className={cx({
                      [styles.selectedAssetImage] : isSelected(asset),
                      [styles.assetImage] : !props.attachAssets,
                      [styles.attachableAsset] : props.attachAssets
                  })}
                    />
                  {!_.isEmpty(FileService.fileType(asset.metadata)) &&
                    <p className={cx(styles.fileType)}>{FileService.fileType(asset.metadata)}</p>
                  }
                </span>
                  <div className={styles.frequentlySharedText}>
                   <InlineEllipsis
                      text={asset.name}
                      className={styles.frequentlySharedHeading}
                    />
                    <p className={styles.frequentlySharedSubHeading}>
                      {assetSummary &&
                      <>
                        <span className={styles.assetSummary}>{assetSummary}</span>
                        <span className={styles.divider}></span>
                      </>
                      }
                      <span>{FileService.formatSize(asset.metadata.content_length)}</span>
                    </p>
                    {asset.modifiedDate != null && 
                      <p className={styles.frequentlySharedSubText}>last update {dateformat(asset.modifiedDate, 'dd mmm yyyy')}</p>
                    }
                  </div>
                  <div className={styles.attachContainer}>
                    <button
                      className={cx(styles.action, styles.attachAction, {})}
                      onClick={(e) => {
                        e.stopPropagation();
                        e.preventDefault();
                        props.attachAssets ? handleSelectAsset(asset) : handleGenerateLink(asset);
                      }}
                    >
                      <i
                        className={cx(styles.attachIcon, {
                          "paperflite-link": !props.attachAssets,
                          "paperflite-cursor": props.attachAssets,
                        })}
                      ></i>
                    </button>
                  </div>
              </a>
            )
          })}
          {frequentlySharedAssetsLoading && _.times(5).map((i) => {
            return (
              <div key={i} className={styles.asset}>
                <span className={cx(styles.assetIcon, {
                
                })}>
                  <img
                    alt="asset thumbnail"
                    src={defaultAsset}
                    className={styles.assetImage} 
                    />
                </span>
                {!props.carousel &&
                  <div className={styles.frequentlySharedText}>
                    <p className={cx(styles.frequentlySharedLoading, styles.frequentlySharedHeading)}>Asset Name</p>
                    <p className={cx(styles.frequentlySharedSubText, styles.frequentlySharedLoading, styles.frequentlySharedSubTextLoading)}>Last updated</p>
                  </div>
                }
              </div>)
          })
          }
          </div>
          )}

          {props.carousel && (
          <div className={styles.gridContainer}>
          {!frequentlySharedAssetsLoading && frequentlySharedAssets.slice(0, 4).map((asset, i) => {
            return (
              <a key={asset.id} className={styles.gridItem}
              href={isPaperflite ? null : `${webAppUrl}/assets/${asset.id}?source=chrome_extension`}
              target="_blank"
              onClick={(e) => {
                e.stopPropagation();
                handleClick(asset);
              }}
              >
                <div className={styles.gridItemContent}>
                  {asset.settings && !asset.settings.share && <LockIcon />}
                  <img
                    alt="asset thumbnail"
                    src={_.get(asset, "icon.thumbnail") || defaultAsset} 
                    className={styles.gridItemImage}
                  />
                  <div className={styles.gridItemInfo}>
                    <p className={styles.gridItemTitle}>
                     <InlineEllipsis
                      text={asset.name}
                    />
                    </p>
                  </div>
                
                </div>
              </a>
            )
          })}
          {frequentlySharedAssetsLoading && _.times(4).map((i) => (
            <div key={i} className={styles.gridItem}>
              <div className={styles.gridItemContent}>
                <img
                  alt="asset thumbnail"
                  src={defaultAsset}
                  className={styles.gridItemImage}
                />
                <div className={styles.gridItemInfo}>
                  <p className={styles.gridItemTitle}>Loading...</p>
                </div>
              </div>
            </div>
          ))}
          {!frequentlySharedAssetsLoading && _.size(frequentlySharedAssets) === 0 && (
            <div className={styles.empty}>
              No frequently shared assets
            </div>
          )}
        </div>
          )}

        {_.size(assets) > 0 && (
          <div className={styles.footer}>
            <div className={styles.attachAssetsContainer} onClick={handleAttachAssets}>
            <i className={cx(styles.sendIcon, "paperflite-cursor")} />
            <span className={styles.attachAssets}>Attach assets ({_.size(assets)})
            <i className="paperflite-close" onClick={(e) => {
              e.stopPropagation();
              setSelectedAssets([]);
              dispatch(invalidateAssetSelection())}} />
            </span>
            </div>
          </div>
        )}
        </div>

      </div>
    </>
  )
}